<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { formatBaseCurrencyString, isMobile, isTablet, loggedIn, refreshSelfInfo, refreshVipLevels, refreshVipState, stateNextLevelUpCashback, stateUserLevelNum, stateUsername, stateUserNextRankDisplay, stateUserSublevelNum, stateUserVipRankDisplay, stateVipProgress } from "@infinitro/global";
import { Icon } from "@infinitro/rank-badges";
import { Text } from "@infinitro/text";
import ProgressBar from "../progress-bar.svelte";
let didRefreshOnLogin = false;
export let rankIconSizeMobile = 90;
export let rankIconSizeDesktop = 160;
$: isPhone = $isMobile && !$isTablet;
$: if ($loggedIn && !didRefreshOnLogin) {
	didRefreshOnLogin = true;
	refreshVipLevels();
	refreshSelfInfo();
	refreshVipState();
}
$: if (!$loggedIn) {
	didRefreshOnLogin = false;
}
</script>

<div class="big-card-player">
	<div class="big-card-content-container">
		<div class="big-card-content">
			<div class="username-rank-container">
				{#key `${$isMobile}-${$isTablet}`}
					<Text
						type="subtitle"
						subtitleWeight="bold"
						subtitleSize={isPhone ? 'small' : 'large'}
						customStyle="font-size: {isPhone ? '18px' : '28px'};">{$stateUsername ?? ''}</Text
					>
				{/key}
			</div>
			<div class="rank-badge" style:font-size={isPhone ? '10px' : '13px'}>
				{$stateUserVipRankDisplay ?? ''}
			</div>
			<div class="progress-section">
				{#key `${$isMobile}-${$isTablet}`}
					<Text
						bodySize={isPhone ? 'xsmall' : 'large'}
						bodyWeight="semibold"
						customStyle="font-size: {isPhone
							? '12px'
							: ''}; text-transform: uppercase; opacity: 0.8;"
						>{$t(Verbiage.progress_to_rank, 'global', { rank: $stateUserNextRankDisplay })}</Text
					>
				{/key}
				<div class="progress-row">
					<div class="progress-bar-wrap">
						<ProgressBar progress={$stateVipProgress} height={$isMobile ? '12px' : '16px'} />
					</div>
					<span class="progress-percent" style:font-size={isPhone ? '14px' : '14px'}>
						{$stateVipProgress}%
					</span>
				</div>
			</div>
			<div class="next-reward-box">
				{#key `${$isMobile}-${$isTablet}`}
					<Text
						bodySize={isPhone ? 'xsmall' : 'large'}
						bodyWeight="semibold"
						customStyle="font-size: {isPhone ? '12px' : '13px'}; text-transform: uppercase;"
						>{$t(Verbiage.next_reward)}</Text
					>
					<Text
						bodySize={isPhone ? 'xsmall' : 'large'}
						bodyWeight="bold"
						customStyle="font-size: {isPhone
							? '12px'
							: '13px'}; font-weight: 500; color: var(--color-highlight-3);"
						>{$stateNextLevelUpCashback
							? formatBaseCurrencyString($stateNextLevelUpCashback)
							: ''}</Text
					>
				{/key}
			</div>
		</div>
		<div class="big-card-rank-container">
			<img
				src={cfgToThemeCdnPath('/top-section/campaign-hero/badge-bg.png')}
				alt=""
				class="badge-bg"
			/>
			<div class="rank-icon-abs">
				{#key $isMobile}
					<Icon
						rank={$stateUserLevelNum}
						level={$stateUserSublevelNum}
						size={isPhone ? rankIconSizeMobile : rankIconSizeDesktop}
					/>
				{/key}
			</div>
		</div>
	</div>
</div>

<style>
	.big-card-player {
		position: relative;
		display: flex;
		height: auto;
		min-height: 150px;
		width: 100%;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		border-radius: 12px;
		box-shadow: 0px 0px 5px 0px rgba(var(--color-primary-500-rgb) / 0.5);
		background: linear-gradient(
			180deg,
			var(--color-tertiary-900) 0%,
			var(--color-tertiary-700) 100%
		);
		aspect-ratio: 60 / 25;
}

	.big-card-player::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		border-radius: 12px;
		padding: 1px;
		background: linear-gradient(
			180deg,
			rgba(var(--color-highlight-4-rgb) / 0.9) 0%,
			rgba(255, 255, 255, 0) 100%
		);
		-webkit-mask:
			linear-gradient(#fff 0 0) content-box,
			linear-gradient(#fff 0 0);
		-webkit-mask-composite: xor;
		mask-composite: exclude;
		pointer-events: none;
		z-index: 1;
	}

	.big-card-content {
		position: relative;
		display: flex;
		height: auto;
		min-height: 87px;
		width: 50%;
		flex-direction: column;
		justify-content: center;
		gap: 1rem;
		z-index: 2;
}

	.rank-badge {
		display: inline-flex;
		height: 30px;
		width: -moz-fit-content;
		width: fit-content;
		align-items: center;
		justify-content: center;
		background-color: var(--color-background-900);
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		font-weight: 700;
		text-transform: uppercase;
		color: var(--color-highlight-3);
		border: 1px solid var(--color-highlight-4);
		border-radius: 4px;
}

	.progress-section {
		display: flex;
		width: 100%;
		flex-direction: column;
		gap: 0.375rem;
}

	.progress-row {
		display: flex;
		width: 100%;
		align-items: center;
		gap: 0.75rem;
}

	.progress-bar-wrap {
		flex: 1 1 0%;
}

	.progress-percent {
		white-space: nowrap;
		font-weight: 500;
		color: var(--color-highlight-4);
}

	.next-reward-box {
		display: flex;
		height: 30px;
		width: 200%;
		align-items: center;
		justify-content: space-between;
		background-color: var(--color-background-900);
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		border: 1px solid var(--color-highlight-4);
		border-radius: 4px;
}

	.big-card-content-container {
		display: flex;
		height: 100%;
		width: 100%;
		align-items: center;
		justify-content: space-between;
		gap: 1rem;
		padding: 1rem;
}

	.big-card-rank-container {
		position: relative;
		height: 100%;
		width: 40%;
		transform: translateY(-20px);
}

	.badge-bg {
		pointer-events: none;
		position: absolute;
		top: 50%;
		left: 50%;
		--tw-translate-x: -50%;
		--tw-translate-y: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		-webkit-user-select: none;
		   -moz-user-select: none;
		        user-select: none;
		width: auto;
		height: 130px;
		max-width: none;
}

	.rank-icon-abs {
		position: absolute;
		top: 50%;
		left: 50%;
		display: flex;
		--tw-translate-x: -50%;
		--tw-translate-y: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		align-items: center;
		justify-content: center;
		line-height: 0;
}

	@media (min-width: 640px) {
		.big-card-player {
				height: 100%;
				min-height: 240px;
			aspect-ratio: 75 / 45;
		}

		.big-card-content {
				height: 100%;
				max-height: none;
				width: 100%;
		}

		.next-reward-box {
				width: 100%;
		}

		.big-card-content-container {
				padding: 1.5rem;
		}

		.big-card-rank-container {
			transform: none;
		}

		.badge-bg {
			height: 230px;
		}
	}

	@media (min-width: 1024px) {
		.big-card-player {
				height: 100%;
			aspect-ratio: 60 / 25;
		}

		.big-card-content {
				height: 100%;
				max-height: none;
				width: 60%;
		}

		.big-card-content-container {
				padding: 1.5rem;
		}
	}
</style>
